
export enum ReportType {
    InvestorDividendLetter = 1,
    PortfolioStatement = 2,
    InterCompanyDividendLetter = 4,
    IssuerDividendLetter = 5,
    BankTransferFormDividend = 3,
    BankTransferFormCapital = 6,
}

export interface ReportTypeInfo {
    requiredSignatories: number;
    maximumSignatories: number;
}

export function GetReportTypeInfo(reportType: ReportType): ReportTypeInfo {
    switch (reportType) {
        case ReportType.InvestorDividendLetter:
        case ReportType.IssuerDividendLetter:
            return { requiredSignatories: 2, maximumSignatories: 0 };
        case ReportType.PortfolioStatement:
            return { requiredSignatories: 0, maximumSignatories: 0 };
        case ReportType.BankTransferFormDividend:
        case ReportType.BankTransferFormCapital:
            return { requiredSignatories: 3, maximumSignatories: 3 };
        case ReportType.InterCompanyDividendLetter:
            return { requiredSignatories: 4, maximumSignatories: 4 };
        
        default:
            throw new Error(`Unknown report type: ${reportType}`);
    }
}